<template>
  <PflegeButton
    variant="secondary"
    icon="download-line"
    icon-position="right"
    :label="downloadLabel"
    :tracking-label="trackingLabel"
    @click.stop.prevent="getDownloadFile"
  />
</template>

<script lang="ts" setup>
import PflegeButton from '../Button'

export interface DownloadButtonProps {
  downloadLabel: string
  downloadUrl?: string
  trackingLabel?: string
}

const {
  downloadLabel,
  downloadUrl = '',
  trackingLabel,
} = defineProps<DownloadButtonProps>()

const getDownloadFile = async () => {
  const downloadName = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1)
  const response = await fetch(downloadUrl)
  const blob = await response.blob()
  const newBlob = new Blob([blob])
  const downloadPath = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')

  link.href = downloadPath
  link.download = downloadName

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>
